import { splitNameAndExtension } from '@qmu/common/util/general';

export const createJsonFileName = (id: string, title: string) => {
  const extension = 'json';
  const { name } = splitNameAndExtension(title);
  if (name) return `${name}_${id}.${extension}`;
  return `${id}.${extension}`;
};
